import localStorageIds from '../constants/localStorageIds'

// `v1/orgs` embeds every team of the org (1,500+ for a federation, ~120 KB), and the selected org
// is read and parsed all over the app, so it is stored without them. Teams come from the teams
// query instead.
const storableOrg = (org) => {
  if (!org || typeof org !== 'object') return org
  const rest = { ...org }
  delete rest.teams
  return rest
}

// Sessions started before the teams were left out still hold them; drop them once at startup.
export const stripStoredOrgTeams = () => {
  try {
    const raw = localStorage.getItem(localStorageIds.SELECTED_ORG)
    if (!raw || !raw.includes('"teams"')) return
    localStorage.setItem(localStorageIds.SELECTED_ORG, JSON.stringify(storableOrg(JSON.parse(raw))))
  } catch {
    // Unreadable value: leave it for the app to replace on the next org selection.
  }
}

export default storableOrg
